<template>
  <b-container class="my-5">
    <b-row>
      <b-col offset-lg="3" lg="6">
        <b-card class="text-center">
          <b-form-group
            label="Start text"
            label-for="textInput"
            label-size="lg"
            description="You may give the generator a small text to start from."
          >
            <b-form-input
              id="temperatureInput"
              v-model="startText"
              maxlength="100"
            />
          </b-form-group>
          <b-form-group
            label="Genre"
            label-for="categoryInput"
            label-size="lg"
            description="The type of song text that you wish to generate."
          >
            <b-form-radio-group
              id="categoryInput"
              v-model="selectedCategory"
              :options="categoryOptions"
            />
          </b-form-group>
          <b-form-group
            label="Temperature"
            label-for="temperatureInput"
            label-size="lg"
            description="Higher temperatures makes the text more random."
          >
            <b-form-input
              id="temperatureInput"
              v-model="temperature"
              type="range"
              min="0.1"
              max="1"
              step="0.01"
            />
          </b-form-group>
          <b-btn
            variant="primary"
            @click="generateSong"
          >
            Generate lyrics
          </b-btn>
          <div v-if="loading" class="text-primary mt-2">
            <b-spinner />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="mt-5">
          The lyrics generator has been trained on 53,684 song texts that were obtained from
          <a href="https://genius.com/">genius.com</a> by using their public API. The songs represent
          all the available songs from artists present in the Danish Wikipedia list of
          <a href="https://da.wikipedia.org/wiki/Kategori:Rappere_fra_USA">American rappers</a>,
          Danish Wikipedia list of
          <a href="https://da.wikipedia.org/wiki/Kategori:Singer-songwritere_fra_USA">American singer-songwriters</a>,
          and Swedish Wikipedia list of
          <a href="https://sv.wikipedia.org/wiki/Kategori:Amerikanska_countrys%C3%A5ngare">American country singers</a>.
          The underlying model has been trained to predict the next word conditioned on the previous
          words and the genre.
        </div>

        <b-modal
          ref="lyrics-modal"
          title="Generated lyrics"
          size="lg"
          ok-only
        >
          <pre>{{ generatedText }}</pre>
        </b-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import { endpoints } from '../constants';

export default {
  name: 'songWriter',
  data() {
    return {
      selectedCategory: 'Rap',
      categoryOptions: ['Rap', 'Country', 'Singer-Songwriter'],
      temperature: 0.7,
      startText: '',
      generatedText: '',
      loading: false,
    };
  },
  methods: {
    async generateSong() {
      console.log('generating song');
      const data = {
        startText: this.startText,
        category: this.selectedCategory,
        temperature: this.temperature,
      };
      this.loading = true;
      const response = await axios.get(endpoints.songGenerate, { params: data });
      this.loading = false;
      this.generatedText = response.data.text;
      this.$refs['lyrics-modal'].show();
    },
  },
};
</script>

<style scoped>

</style>
